// extracted by css-extract-rspack-plugin
export default {"pre-line":"knZFrRP___pre-line","preLine":"knZFrRP___pre-line"};